import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getUtilityButton, Icon, LoaderButton } from '@livable/saas-react-components';
import { Box, Container, Typography, Grid, Button, ToggleButtonGroup, ToggleButton, Link } from '@mui/material';
import React, { useState } from 'react';
import SocialButton from 'src/components/general/SocialButtons';
import useStyles from '../styles';
const loadingButtonsExample = "\nimport { LoaderButton } from '@livable/saas-react-components';\n\n<LoaderButton\n  buttonText=\"Confirm enrollment\"\n  disabled // false by default\n  errorText=\"Submitting failed\"\n  fullWidth // false by default\n  loadingText=\"Submitting...\"\n  status=\"error\"\n  successText=\"Submitted successfully\"\n  variant=\"priority\" // \"contained\" by default\n/>\n\nstatus variants: error, inProgress, success";
const socialButtonsExample = "\nimport { SocialButton  } from 'src/components/general/SocialButtons';\n\n<SocialButton type=\"google\" />";
const actionBarButtonsExample = "\n<Button variant=\"action\">\n  <Icon type=\"coin\" />\n  Setup auto-pay\n</Button>";
const actionIconsExample = "\n<Button variant=\"actionIcon\" size=\"small\">\n  <Icon type=\"team-group\" />\n</Button>\n<Button variant=\"actionIcon\" size=\"small\" state=\"active\">\n  <Icon type=\"team-group\" />\n</Button>\n<Button variant=\"actionIcon\" size=\"small\" state=\"activeLight\">\n  <Icon type=\"team-group\" />\n</Button>";
const bigActionIconsExample = "\n<Button variant=\"actionIcon\" size=\"large\">\n  <Icon type=\"team-group\" />\n</Button>\n<Button variant=\"actionIcon\" size=\"large\" state=\"active\">\n  <Icon type=\"team-group\" />\n</Button>\n<Button variant=\"actionIcon\" size=\"large\" state=\"activeLight\">\n  <Icon type=\"team-group\" />\n</Button>";
const actionButtonExample = "\n<Button variant=\"actionButton\">\n  <span className=\"actionText\">Options</span>\n  <Icon type=\"plus\" />\n</Button>\n\n<Button variant=\"actionButton\" state=\"active\">\n  <span className=\"actionText\">Options</span>\n  <Icon type=\"plus\" />\n</Button>\n\n<Button variant=\"actionButton\">\n  <Icon type=\"plus\" />\n  <span className=\"actionText\">Options</span>\n</Button>\n\n<Button variant=\"actionButton\" state=\"active\">\n  <Icon type=\"plus\" />\n  <span className=\"actionText\">Options</span>\n</Button>";
const utilityButtonExample = "\nimport { getUtilityButton } from '@livable/saas-react-components';\n\nconst utility = getUtilityButton('Name of the utility with upper case first letter', state, id, handleClick);\n\nutilities:\n- Cable\n- Television\n- Gas-heat\n- District heat\n- Natural gas\n- Propane\n- Steam\n- Fuel oil\n- Electric\n- Electricity\n- Lighting\n- Irrigation\n- Landscaping\n- Chilled water\n- Water\n- Landline phone\n- Phone\n- Electricity-com\n- Hot-water\n- Internet\n- Telecom\n- Pest\n- Sanitation\n- Satelite\n- Sewer\n- Solar\n- Trash\n- Other";
const hugeButtonExample = "\n<Button variant=\"huge\">View my details</Button>";
const priorityButtonExample = "\n<Button variant=\"priority\">Button text</Button>\n<Button variant=\"priority\" disabled>Button text</Button>";
const priorityButtonSmallExample = "\n<Button variant=\"priority\" size=\"small\">Button text</Button>\n<Button variant=\"priority\" size=\"small\" disabled>Button text</Button>";
const primaryButtonExample = "\n<Button variant=\"contained\">Button text</Button>\n<Button variant=\"contained\" disabled>Button text</Button>";
const primaryButtonSmallExample = "\n<Button variant=\"contained\" size=\"small\">Button text</Button>\n<Button variant=\"contained\" size=\"small\" disabled>Button text</Button>";
const secondaryButtonExample = "\n<Button variant=\"text\">Button text</Button>\n<Button variant=\"text\" disabled>Button text</Button>";
const secondaryButtonSmallExample = "\n<Button variant=\"text\" size=\"small\">Button text</Button>\n<Button variant=\"text\" size=\"small\" disabled>Button text</Button>";
const buttonGroupExample = "\n<ToggleButtonGroup value=\"one\" exclusive>\n  <ToggleButton value=\"one\">Active one</ToggleButton>\n  <ToggleButton value=\"two\">Inactive</ToggleButton>\n</ToggleButtonGroup>";
const buttonSmallGroupExample = "\n<ToggleButtonGroup value=\"one\" size=\"small\" exclusive>\n  <ToggleButton value=\"one\">Active one</ToggleButton>\n  <ToggleButton value=\"two\">Inactive</ToggleButton>\n</ToggleButtonGroup>";
export default function LvButtons() {
  const classes = useStyles();
  const statuses = ['error', 'loader', 'success'];
  const utilities = ['Cable', 'Television', 'Gas-heat', 'District heat', 'Natural gas', 'Propane', 'Steam', 'Fuel oil', 'Electric', 'Electricity', 'Lighting', 'Irrigation', 'Landscaping', 'Chilled water', 'Water', 'Landline phone', 'Phone', 'Electricity-com', 'Hot-water', 'Internet', 'Telecom', 'Pest', 'Sanitation', 'Satelite', 'Sewer', 'Solar', 'Trash', 'Other'];
  const _useState = useState({
      cable: 'activePrimary',
      television: 'activePrimary',
      'gas-heat': 'activePrimary',
      'district heat': 'activePrimary',
      'natural gas': 'activePrimary',
      propane: '',
      steam: 'activePrimary',
      'fuel oil': 'activePrimary',
      electric: 'activePrimary',
      electricity: 'activePrimary',
      lighting: 'activePrimary',
      irrigation: 'activePrimary',
      landscaping: 'activePrimary',
      'chilled water': '',
      water: 'activePrimary',
      'landline phone': 'activePrimary',
      phone: 'activePrimary',
      'electricity-com': 'activePrimary',
      'hot-water': 'activePrimary',
      internet: '',
      telecom: 'activePrimary',
      pest: 'activePrimary',
      sanitation: '',
      satelite: 'activePrimary',
      sewer: 'activePrimary',
      solar: '',
      trash: 'activePrimary',
      other: 'activePrimary'
    }),
    _useState2 = _slicedToArray(_useState, 2),
    utilityObj = _useState2[0],
    setUilityObj = _useState2[1];
  const changeUtility = (utility, status) => {
    setUilityObj(_objectSpread(_objectSpread({}, utilityObj), {}, {
      [utility]: status
    }));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h1",
    className: classes.section
  }, "Buttons and actions"), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h2",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement("span", null, "Buttons "), /*#__PURE__*/React.createElement(Link, {
    href: "https://mui.com/material-ui/react-button/",
    target: "_blank"
  }, "(documentation)")), /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Loading Buttons"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 24
  }, statuses.map(status => /*#__PURE__*/React.createElement(Grid, {
    key: status,
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(LoaderButton, {
    buttonText: "Confirm enrollment",
    errorText: "Submission failed",
    loadingText: "Submitting...",
    status: status,
    successText: "Submitted successfully"
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(LoaderButton, {
    loadingText: "Submitting...",
    buttonText: "Confirm enrollment",
    successText: "Submitted successfully",
    errorText: "Submission failed",
    status: "error",
    fullWidth: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, loadingButtonsExample))), /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Social Buttons"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(SocialButton, {
    type: "google"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(SocialButton, {
    type: "facebook"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(SocialButton, {
    type: "apple"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(SocialButton, {
    type: "twitter"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(SocialButton, {
    type: "linkedin"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(SocialButton, {
    type: "microsoft"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, socialButtonsExample))), /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Action bar button"), /*#__PURE__*/React.createElement(Button, {
    variant: "action"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "coin"
  }), "Setup auto-pay"), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, actionBarButtonsExample), /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Action icon"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "small"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "team-group"
  })), /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "small",
    state: "active"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "team-group"
  })), /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "small",
    state: "activeLight"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "team-group"
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "large"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "team-group"
  })), /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "large",
    state: "active"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "team-group"
  })), /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "large",
    state: "activeLight"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "team-group"
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, actionIconsExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, bigActionIconsExample))), /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Action button"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton"
  }, /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Options"), /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  })), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    state: "active"
  }, /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Options"), /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  })), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Options")), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    state: "active"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Options"))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, actionButtonExample))), /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Utility selector bar"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, utilityButtonExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, utilities.map((u, i) => getUtilityButton(u, utilityObj[u], i, () => changeUtility(u, utilityObj[u] === 'activePrimary' ? 'activeSecondary' : 'activePrimary'))))), /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Huge button"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "huge"
  }, "View my details"), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, hugeButtonExample))), /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Priority"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "priority"
  }, "Button text")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "priority",
    disabled: true
  }, "Button text")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "priority",
    size: "small"
  }, "Button text")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "priority",
    size: "small",
    disabled: true
  }, "Button text")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, priorityButtonExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, priorityButtonSmallExample))), /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Primary"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained"
  }, "Button text")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    disabled: true
  }, "Button text")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "small"
  }, "Button text")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "small",
    disabled: true
  }, "Button text")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, primaryButtonExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, primaryButtonSmallExample))), /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Secondary"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text"
  }, "Button text")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    disabled: true
  }, "Button text")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    size: "small"
  }, "Button text")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    size: "small",
    disabled: true
  }, "Button text")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, secondaryButtonExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, secondaryButtonSmallExample))), /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h2",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement("span", null, "Button group variants "), /*#__PURE__*/React.createElement(Link, {
    href: "https://mui.com/material-ui/react-toggle-button/#color",
    target: "_black"
  }, "(documentation)")), /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Regular"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    value: "one",
    exclusive: true
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "one"
  }, "Active one"), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "two"
  }, "Inactive"), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "three"
  }, "Inactive"), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "four"
  }, "Inactive"), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "five"
  }, "Inactive"), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "six"
  }, "Inactive"), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "seven"
  }, "Inactive"), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "eight"
  }, "Inactive"))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    value: "one",
    exclusive: true
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "one"
  }, "Active one"), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "two"
  }, "Inactive"), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "three"
  }, "Inactive"))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    value: "one",
    exclusive: true
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "one"
  }, "Active one"), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "two"
  }, "Inactive"))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, buttonGroupExample))), /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Small"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    value: "one",
    size: "small",
    exclusive: true
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "one"
  }, "Active one"), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "two"
  }, "Inactive"), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "three"
  }, "Inactive"), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "four"
  }, "Inactive"), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "five"
  }, "Inactive"), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "six"
  }, "Inactive"), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "seven"
  }, "Inactive"), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "eight"
  }, "Inactive"))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    value: "one",
    size: "small",
    exclusive: true
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "one"
  }, "Active one"), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "two"
  }, "Inactive"), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "three"
  }, "Inactive"))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    value: "one",
    size: "small",
    exclusive: true
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "one"
  }, "Active one"), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "two"
  }, "Inactive"))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, buttonSmallGroupExample))))));
}